import request from '../utils/request'

// ==================== 消息管理 ====================

/**
 * 获取消息列表
 */
export function getMessageList(params) {
  return request({
    url: '/message/list',
    method: 'get',
    params
  })
}

/**
 * 获取消息分类汇总（PC端分类卡片）
 */
export function getMessageCategorySummary() {
  return request({
    url: '/message/category-summary',
    method: 'get'
  })
}

/**
 * 获取消息详情
 */
export function getMessageDetail(id) {
  return request({
    url: '/message/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 标记消息为已读
 */
export function markMessageAsRead(id) {
  return request({
    url: '/message/mark-read',
    method: 'post',
    params: { id }
  })
}

/**
 * 批量标记所有未读消息为已读
 */
export function markAllUnreadAsRead() {
  return request({
    url: '/message/mark-all-read',
    method: 'post'
  })
}

/**
 * 获取未读消息数量
 */
export function getUnreadMessageCount() {
  return request({
    url: '/message/unread-count',
    method: 'get'
  })
}

